import * as types from './types';

const initialState = {
  levelValue: null,
  loading: false,
  recievedSuccessfulResponse: false,
  recievedErrorResponse: false,
  levelComparison: false
};

function reputationLevelReducer(state = initialState, action) {
  switch (action.type) {
    case types.GET_REPUTATION_LEVEL:
      return {
        ...state,
        loading: true,
        recievedSuccessfulResponse: false,
        recievedErrorResponse: false
      };

    case types.GET_REPUTATION_LEVEL_COMPLETED:
      return {
        ...state,
        levelValue: action.payload.level,
        levelComparison: action.payload.levelComparison,
        loading: false,
        recievedSuccessfulResponse: true
      };

    case types.GET_REPUTATION_LEVEL_FAILED:
      return {
        ...state,
        loading: false,
        recievedErrorResponse: true
      };

    default:
      return state;
  }
}

export default reputationLevelReducer;
